import React from 'react';

const PriceDisplay = ({ 
  price, 
  oldPrice, 
  discount,
  size = 'medium' // small, medium, large
}) => {
  const hasDiscount = discount > 0 && oldPrice && oldPrice > price;

  // Size classes
  const sizeClasses = {
    small: {
      price: 'text-base',
      oldPrice: 'text-xs',
      badge: 'text-xs px-2 py-0.5',
      discount: 'text-xs'
    },
    medium: {
      price: 'text-xl',
      oldPrice: 'text-sm',
      badge: 'text-xs px-2 py-1',
      discount: 'text-sm'
    },
    large: {
      price: 'text-3xl',
      oldPrice: 'text-base',
      badge: 'text-sm px-3 py-1',
      discount: 'text-base'
    }
  };

  const classes = sizeClasses[size];

  if (!hasDiscount) {
    // İndirim yok - sadece kırmızı fiyat
    return (
      <div className="flex items-center gap-2">
        <span className={`text-red-600 font-bold ${classes.price}`}>
          {price.toLocaleString('tr-TR')} TL
        </span>
      </div>
    );
  }

  // İndirim var - tam gösterim
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2 flex-wrap">
        <span className={`inline-block bg-red-600 text-white font-semibold ${classes.badge} rounded`}>
          İNDİRİMDE
        </span>
        <span className={`text-red-600 font-bold ${classes.price}`}>
          {price.toLocaleString('tr-TR')} TL
        </span>
      </div>
      <div className="flex items-center gap-2">
        <span className={`text-gray-400 line-through ${classes.oldPrice}`}>
          {oldPrice.toLocaleString('tr-TR')} TL
        </span>
        <span className={`text-green-600 font-semibold ${classes.discount}`}>
          -%{discount}
        </span>
      </div>
    </div>
  );
};

export default PriceDisplay;
